module.exports = __webpack_public_path__ + "static/1-intro-background-3d0be70049208ee8460602aba48e6069.png";